export default __webpack_public_path__ + "static/Header-c2228c243b43636e3f6580abbd6558cf.png";